"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MapsService", {
    enumerable: true,
    get: function() {
        return MapsService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _globals = require("~/utils/globals");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let MapsService = class MapsService {
    async mapViewGet(context, param) {
        return await _models.MapView.get(context, param.mapViewId);
    }
    async mapViewCreate(context, param) {
        var _param_user, _param_user1;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ViewCreateReq', param.map);
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const model = await _models.Model.get(context, param.tableId);
        const { id } = await _models.View.insertMetaOnly(context, {
            view: _extends({}, param.map, {
                // todo: sanitize
                fk_model_id: param.tableId,
                type: _nocodbsdk.ViewTypes.MAP,
                base_id: model.base_id,
                source_id: model.source_id,
                created_by: (_param_user = param.user) == null ? void 0 : _param_user.id,
                owned_by: (_param_user1 = param.user) == null ? void 0 : _param_user1.id
            }),
            model,
            req: param.req
        });
        // populate  cache and add to list since the list cache already exist
        const view = await _models.View.get(context, id);
        await _NocoCache.default.appendToList(context, _globals.CacheScope.VIEW, [
            view.fk_model_id
        ], `${_globals.CacheScope.VIEW}:${id}`);
        const owner = param.req.user;
        this.appHooksService.emit(_nocodbsdk.AppEvents.MAP_CREATE, {
            view,
            req: param.req,
            owner,
            context
        });
        return view;
    }
    async mapViewUpdate(context, param) {
        var _param_req_user;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/MapUpdateReq', param.map);
        const view = await _models.View.get(context, param.mapViewId);
        if (!view) {
            _catchError.NcError.get(context).viewNotFound(param.mapViewId);
        }
        await _models.MapView.update(context, param.mapViewId, param.map);
        let owner = param.req.user;
        if (view.owned_by && view.owned_by !== ((_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id)) {
            owner = await _models.User.get(view.owned_by);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.MAP_UPDATE, {
            view: _extends({}, view, param.map),
            oldView: view,
            req: param.req,
            context,
            owner
        });
        await view.getView(context);
        return view;
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
MapsService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], MapsService);
